import { render } from "./order_list_bootstrap.vue?vue&type=template&id=222169d6"
import script from "./order_list_bootstrap.vue?vue&type=script&lang=js"
export * from "./order_list_bootstrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__